export const hu = {
  // App
  appName: 'Autós Utazás',
  
  // Auth
  signIn: 'Bejelentkezés',
  signUp: 'Regisztráció',
  signOut: 'Kilépés',
  email: 'Email',
  emailAddress: 'Email Cím',
  password: 'Jelszó',
  fullName: 'Teljes Név',
  enterEmail: 'Add meg az email címed',
  enterPassword: 'Add meg a jelszavad',
  enterFullName: 'Add meg a teljes neved',
  authentication: 'Bejelentkezés',
  planTripsEase: 'Tervezd meg utazásaid egyszerűen',
  loginRequired: 'Bejelentkezés Szükséges',
  loginRequiredDescription: 'Kérlek jelentkezz be az útvonal megállók létrehozásához és kezeléséhez',
  
  // Navigation
  home: 'Főoldal',
  profile: 'Profil',
  settings: 'Beállítások',
  menu: 'Menü',
  analytics: 'Analitika',
  
  // Trips
  myTrips: 'Utazásaim',
  newTrip: 'Új Utazás',
  selectTrip: 'Válassz Utazást',
  tripName: 'Utazás Neve',
  createTrip: 'Utazás Létrehozása',
  deleteTrip: 'Utazás Törlése',
  noTrips: 'Még nincs utazásod. Hozd létre az elsőt!',
  stops: 'megálló',
  stopsTitle: 'Megállók',
  tripHistory: 'Utazási Előzmények',
  searchTrips: 'Utazások keresése...',
  all: 'Összes',
  noTripsFound: 'Nincs Találat',
  createTripsToSeeHistory: 'Hozz létre utazásokat az előzmények megtekintéséhez',
  sortBy: 'Rendezés',
  newestFirst: 'Legújabb először',
  oldestFirst: 'Legrégebbi először',
  nameAZ: 'Név (A-Z)',
  nameZA: 'Név (Z-A)',
  longestDistance: 'Leghosszabb távolság',
  highestCost: 'Legmagasabb költség',
  cost: 'Költség',
  complete: 'Befejezés',
  archive: 'Archiválás',
  restore: 'Visszaállítás',
  view: 'Megtekintés',
  tripCompleted: 'Utazás befejezettként jelölve',
  tripArchived: 'Utazás sikeresen archiválva',
  tripRestored: 'Utazás sikeresen visszaállítva',
  tripDeleted: 'Utazás sikeresen törölve',
  errorCompletingTrip: 'Hiba az utazás befejezése során',
  errorDeletingTrip: 'Hiba az utazás törlése során',
  confirmDeleteTrip: 'Biztosan törölni szeretnéd ezt az utazást',
  exportPDF: 'PDF Exportálás',
  exportExcel: 'Excel Exportálás',
  pdfExported: 'PDF sikeresen letöltve',
  excelExported: 'Excel sikeresen letöltve',
  exportFailed: 'Exportálás sikertelen. Próbáld újra.',
  
  // Trip actions
  deleteConfirm: 'Biztosan törölni szeretnéd',
  deleteMessage: 'Ez törölni fogja az összes',
  cancel: 'Mégse',
  delete: 'Törlés',
  close: 'Bezár',
  save: 'Mentés',
  back: 'Vissza',
  
  // Stops
  addStop: 'Megálló Hozzáadása',
  editStop: 'Megálló Szerkesztése',
  deleteStop: 'Megálló Törlése',
  noStops: 'Még nincsenek megállók',
  start: 'Kezdőpont',
  finish: 'Célállomás',
  route: 'Útvonal',
  stop: 'megálló',
  address: 'Cím',
  stopType: 'Megálló Típusa',
  stopName: 'Megálló Neve',
  notes: 'Megjegyzések',
  coordinates: 'Koordináták',
  latitude: 'Szélesség',
  longitude: 'Hosszúság',
  plannedDuration: 'Tervezett Időtartam (perc)',
  selectType: 'Válassz típust',
  useMapCenter: 'Térkép közép használata',
  coordinatesAutoFilled: 'A koordináták automatikusan kitöltődnek cím keresésekor',
  howLongToStay: 'Mennyi időt tervezel itt tölteni?',
  enterStopName: 'Add meg a megálló nevét',
  updateStop: 'Megálló Frissítése',
  
  // Stop types
  city: 'Város',
  gasStation: 'Benzinkút',
  evCharging: 'Elektromos Töltő',
  restArea: 'Pihenő',
  restaurant: 'Étterem',
  fastFood: 'Gyorsétterem',
  cafe: 'Kávézó',
  hotel: 'Szálloda',
  motel: 'Motel',
  camping: 'Kemping',
  attraction: 'Látnivaló',
  museum: 'Múzeum',
  park: 'Park',
  viewpoint: 'Kilátó',
  shopping: 'Bevásárlás',
  parking: 'Parkoló',
  other: 'Egyéb',
  accommodation: 'Szállás',
  
  // Map
  mapLabels: 'Térkép Címkék',
  cityAndStreetNames: 'Város- és utcanevek',
  localLanguage: 'Helyi nyelv',
  englishLanguage: 'Angol',
  
  // Settings
  language: 'Nyelv',
  languageNative: 'Nyelv',
  theme: 'Téma',
  themeLight: 'Világos',
  themeDark: 'Sötét',
  themeAuto: 'Automatikus',
  appearance: 'Megjelenés',
  map: 'Térkép',
  account: 'Fiók',
  security: 'Biztonság',
  
  // Regional settings
  regional: 'Regionális',
  units: 'Mértékegységek',
  distanceUnit: 'Távolság Mértékegység',
  speedUnit: 'Sebesség Mértékegység',
  fuelUnit: 'Fogyasztás Mértékegység',
  currencySettings: 'Pénznem',
  dateTimeFormat: 'Dátum & Idő Formátum',
  dateFormat: 'Dátum Formátum',
  timeFormat: 'Idő Formátum',
  
  // Security & 2FA
  twoFactorAuth: 'Kétfaktoros Hitelesítés',
  twoFactorAuthDescription: 'Adj hozzá egy extra biztonsági réteget a fiókodhoz',
  twoFactorEnabled: '2FA Bekapcsolva',
  twoFactorEnabledDesc: 'A fiókod védve van kétfaktoros hitelesítéssel',
  twoFactorDisabled: '2FA Kikapcsolva',
  twoFactorDisabledDesc: 'Kapcsold be a 2FA-t a fiókod védelméhez',
  setupTwoFactor: 'Kétfaktoros Hitelesítés Beállítása',
  setupTwoFactorStep1: '1. lépés: QR Kód Beolvasása',
  scanQRCode: 'Olvasd be ezt a QR kódot az authenticator alkalmazásoddal',
  cantScanQR: 'Nem tudod beolvasni a QR kódot?',
  enterManually: 'Add meg ezt a kódot manuálisan',
  enterVerificationCode: 'Add meg a 6-számjegyű kódot az authenticator alkalmazásodból',
  verificationCode: 'Ellenőrző Kód',
  verify: 'Ellenőrzés',
  enableTwoFactor: 'Bekapcsolás',
  disableTwoFactor: 'Kikapcsolás',
  next: 'Következő',
  copy: 'Másolás',
  copiedToClipboard: 'Vágólapra másolva',
  invalidVerificationCode: 'Érvénytelen ellenőrző kód',
  errorStartingMFA: 'Hiba a kétfaktoros hitelesítés indításakor',
  errorDisablingMFA: 'Hiba a kétfaktoros hitelesítés kikapcsolásakor',
  disableTwoFactorTitle: 'Kétfaktoros Hitelesítés Kikapcsolása',
  disableTwoFactorConfirm: 'Biztosan kikapcsolod a kétfaktoros hitelesítést? Ez kevésbé teszi biztonságossá a fiókodat.',
  
  // GDPR & Privacy
  privacyAndData: 'Adatvédelem & Adatok',
  privacyDescription: 'Adatvédelmi beállítások, adatok és fiók preferenciák kezelése',
  cookiePreferences: 'Cookie Beállítások',
  manageCookieSettings: 'Süti használat beállítása',
  manageCookies: 'Sütik Kezelése',
  cookieConsentTitle: 'Sütiket használunk',
  cookieConsentMessage: 'Sütiket használunk a felhasználói élmény javítására, forgalom elemzésére és marketing célokra.',
  cookieSettings: 'Süti Beállítások',
  cookieSettingsDescription: 'Válaszd ki, mely sütiket engedélyezed',
  acceptAll: 'Összes Elfogadása',
  cookieNecessary: 'Szükséges Sütik',
  cookieNecessaryDesc: 'Elengedhetetlenek a weboldal megfelelő működéséhez',
  cookieFunctional: 'Funkcionális Sütik',
  cookieFunctionalDesc: 'Megjegyzik a beállításaidat és preferenciáidat',
  cookieAnalytics: 'Analitikus Sütik',
  cookieAnalyticsDesc: 'Segítenek megérteni, hogyan használják a látogatók a weboldalt',
  cookieMarketing: 'Marketing Sütik',
  cookieMarketingDesc: 'Személyre szabott hirdetések megjelenítésére használjuk',
  savePreferences: 'Beállítások Mentése',
  cookiePreferencesSaved: 'Süti beállítások mentve',
  emailPreferences: 'Email Beállítások',
  emailPreferencesDesc: 'Válaszd ki, mely emaileket szeretnéd megkapni',
  marketingEmails: 'Marketing Emailek',
  marketingEmailsDesc: 'Termékfrissítések, tippek és különleges ajánlatok',
  tripReminders: 'Utazás Emlékeztetők',
  tripRemindersDesc: 'Emlékeztetők a közelgő utazásaidról',
  weeklySummary: 'Heti Összefoglaló',
  weeklySummaryDesc: 'Heti áttekintés az utazási aktivitásodról',
  emailPreferencesSaved: 'Email beállítások mentve',
  errorSavingPreferences: 'Hiba a beállítások mentésekor',
  exportYourData: 'Adatok Exportálása',
  exportYourDataDesc: 'Töltsd le az összes adatod másolatát',
  downloadMyData: 'Adataim Letöltése',
  exporting: 'Exportálás...',
  dataExportedSuccessfully: 'Az adataid letöltésre kerültek',
  errorExportingData: 'Hiba az adatok exportálásakor',
  privacyPolicy: 'Adatvédelmi Szabályzat',
  privacyPolicyDesc: 'Olvasd el az adatvédelmi szabályzatunkat és feltételeket',
  viewPrivacyPolicy: 'Adatvédelmi Szabályzat Megtekintése',
  deleteAccount: 'Fiók Törlése',
  deleteAccountDesc: 'Fiók és összes adat végleges törlése',
  deleteMyAccount: 'Fiókom Törlése',
  deleteAccountConfirmTitle: 'Fiók Törlése?',
  deleteAccountConfirmMessage: 'Ez véglegesen törli a fiókodat, összes utazásodat, járműveidet és beállításaidat. Ez a művelet nem vonható vissza.',
  accountDeletedSuccessfully: 'A fiókod törlésre került',
  errorDeletingAccount: 'Hiba a fiók törlésekor',
  
  // Messages
  createFirstTrip: 'Kattints a ➕ gombra az első utazásod létrehozásához',
  noActiveTrip: 'Nincs aktív utazás. Kérlek hozz létre vagy válassz egyet.',
  error: 'Hiba',
  success: 'Siker',
  
  // Trip calculator
  distance: 'Távolság',
  duration: 'Időtartam',
  totalDistance: 'Teljes Távolság',
  totalDuration: 'Teljes Időtartam',
  fuelCost: 'Üzemanyag Költség',
  tripCalculator: 'Utazás Kalkulátor',
  tripSummary: 'Utazás Összegzés',
  fuelConsumption: 'Fogyasztás (L/100km)',
  fuelPrice: 'Üzemanyag Ár (€/L)',
  kilometers: 'Kilométer',
  totalTime: 'Teljes Idő',
  fuelNeeded: 'Szükséges Üzemanyag',
  breakdown: 'Részletezés',
  drivingTime: 'Vezetési idő',
  stopDuration: 'Megállók időtartama',
  avgSpeed: 'Átlag sebesség',
  addTwoStops: 'Adj hozzá legalább 2 megállót a számításokhoz',
  upgradeToPremium: 'Frissítés Prémiumra',
  premiumFeatures: 'Útdíj számítás, benzinkút kereső és további fejlett funkciók',
  upgradeNow: 'Frissítés Most',
  
  // Vehicles
  vehicles: 'Járművek',
  myVehicles: 'Járműveim',
  vehicle: 'Jármű',
  addVehicle: 'Jármű Hozzáadása',
  addNewVehicle: 'Új Jármű Hozzáadása',
  editVehicle: 'Jármű Szerkesztése',
  noVehicles: 'Még nincs jármű',
  vehicleName: 'Jármű Neve',
  selectedVehicle: 'Kiválasztott Jármű',
  noVehicleSelected: 'Nincs kiválasztott jármű',
  customVehicle: 'Egyedi jármű',
  change: 'Módosítás',
  done: 'Kész',
  make: 'Gyártó',
  model: 'Modell',
  year: 'Évjárat',
  fuelType: 'Üzemanyag Típus',
  gasoline: 'Benzin',
  diesel: 'Dízel',
  electric: 'Elektromos',
  hybrid: 'Hibrid',
  pluginHybrid: 'Plug-in Hibrid',
  fuelConsumptionLabel: 'Fogyasztás',
  fuelConsumptionCity: 'Város',
  fuelConsumptionHighway: 'Autópálya',
  fuelConsumptionCombined: 'Vegyes',
  tankCapacity: 'Tank Kapacitás',
  batteryCapacity: 'Akkumulátor Kapacitás',
  range: 'Hatótávolság',
  chargingSpeed: 'Töltési Sebesség',
  color: 'Szín',
  icon: 'Ikon',
  setAsDefault: 'Beállítás alapértelmezettként',
  defaultVehicle: 'Alapértelmezett',
  
  // Cost tracking
  costs: 'Költségek',
  addCost: 'Költség hozzáadása',
  editCost: 'Költség szerkesztése',
  costCategory: 'Kategória',
  costAmount: 'Összeg',
  costDescription: 'Leírás',
  costDate: 'Dátum',
  totalCost: 'Teljes költség',
  fuelCostLabel: 'Üzemanyag költség',
  otherCosts: 'Egyéb költségek',
  
  // Cost categories
  costFuel: 'Üzemanyag',
  costToll: 'Autópályadíj',
  costParking: 'Parkolás',
  costAccommodation: 'Szállás',
  costMeal: 'Étkezés',
  costAttraction: 'Látnivaló',
  costMaintenance: 'Karbantartás',
  costOther: 'Egyéb',
  currency: 'Pénznem',
  linkToStop: 'Megállóhoz kapcsolás',
  optional: 'Opcionális',
  noStop: 'Nincs megálló',
  manage: 'Kezelés',
  topCategories: 'Fő kategóriák',
  
  // POI Search
  searchPOI: 'Helyek keresése',
  allCategories: 'Minden kategória',
  fuelAndCharging: 'Üzemanyag & Töltés',
  foodAndDrink: 'Étkezés',
  accommodationCategory: 'Szállás',
  attractionsCategory: 'Látnivalók',
  parkingCategory: 'Parkolás',
  restAreas: 'Pihenőhelyek',
  shoppingCategory: 'Bevásárlás',
  searchRadius: 'Keresési sugár',
  nearCurrentLocation: 'Közelemben',
  alongRoute: 'Útvonal mentén',
  searching: 'Keresés...',
  search: 'Keresés',
  foundResults: '{count} hely találva',
  noResultsFound: 'Nincs találat',
  tryDifferentSearch: 'Próbálj más kategóriát vagy növeld a sugarat',
  selectCategoryAndSearch: 'Válassz kategóriát és kattints a Keresés gombra',
  locationRequired: 'Jelenlegi helyzet szükséges',
  routeRequired: 'Útvonal szükséges ehhez a kereséshez',
  searchFailed: 'Keresés sikertelen. Próbáld újra.',
  poiServiceUnavailable: 'A POI keresési szolgáltatás átmenetileg nem elérhető. Próbáld újra néhány pillanat múlva.',
  
  // Statistics
  statistics: 'Statisztikák',
  totalTrips: 'Összes utazás',
  totalDistanceTraveled: 'Összes távolság',
  totalCostSpent: 'Összes költség',
  totalTimeSpent: 'Összes idő',
  tripsByStatus: 'Utazások státusz szerint',
  active: 'Aktív',
  completed: 'Befejezett',
  archived: 'Archivált',
  favoriteStopTypes: 'Kedvenc helyek',
  monthlyTrend: 'Havi trend',
  lastTrip: 'Utolsó utazás',
  uniqueStopTypes: 'Egyedi megálló típusok',
  avgTripDistance: 'Átlag távolság',
  avgTripCost: 'Átlag költség',
  noStatisticsYet: 'Még nincs statisztika',
  createTripsToSeeStats: 'Hozz létre utazásokat a statisztikák megtekintéséhez',
  trips: 'utazás',
  
  // Sharing
  shareTrip: 'Utazás megosztása',
  shareLink: 'Megosztási link',
  collaborators: 'Közreműködők',
  shareLinkDescription: 'Hozz létre megosztási linket, hogy mások megtekinthessék vagy szerkeszthessék ezt az utazást',
  createNewLink: 'Új link létrehozása',
  shareType: 'Megosztás típusa',
  viewOnly: 'Csak megtekintés',
  canEdit: 'Szerkeszthető',
  expiresIn: 'Lejárat',
  never: 'Soha',
  '1day': '1 nap',
  '7days': '7 nap',
  '30days': '30 nap',
  creating: 'Létrehozás...',
  createLink: 'Link létrehozása',
  activeLinks: 'Aktív linkek',
  expires: 'Lejár',
  views: 'Megtekintések',
  created: 'Létrehozva',
  revokeLink: 'Link visszavonása',
  confirmRevokeLink: 'Biztosan visszavonod ezt a linket? Többé nem lesz elérhető.',
  revoke: 'Visszavonás',
  linkRevoked: 'Link sikeresen visszavonva',
  linkCreatedAndCopied: 'Link létrehozva és vágólapra másolva',
  linkCopied: 'Link vágólapra másolva',
  errorCreatingLink: 'Hiba a link létrehozása során. Próbáld újra.',
  collaboratorsDescription: 'Hívj meg másokat az utazás szerkesztésére email címmel',
  addCollaborator: 'Közreműködő hozzáadása',
  role: 'Szerep',
  viewer: 'Megtekintő',
  editor: 'Szerkesztő',
  owner: 'Tulajdonos',
  adding: 'Hozzáadás...',
  currentCollaborators: 'Jelenlegi közreműködők',
  unknown: 'Ismeretlen',
  removeCollaborator: 'Közreműködő eltávolítása',
  confirmRemoveCollaborator: 'Biztosan eltávolítod ezt a közreműködőt?',
  remove: 'Eltávolítás',
  collaboratorAdded: 'Közreműködő sikeresen hozzáadva',
  errorAddingCollaborator: 'Hiba a közreműködő hozzáadása során. Ellenőrizd az email címet.',
  collaboratorRemoved: 'Közreműködő sikeresen eltávolítva',
  
  // Shared Trip
  sharedTrip: 'Megosztott Utazás',
  loadingSharedTrip: 'Megosztott utazás betöltése...',
  errorLoadingTrip: 'Hiba az utazás betöltése során',
  goHome: 'Főoldalra',
  sharedBy: 'Megosztotta',
  tripRoute: 'Utazás útvonala',
  distanceToNext: 'Távolság a következő megállóig',
  costBreakdown: 'Költségek részletezése',
  minutes: 'perc',
  
  // Notifications
  notificationSettings: 'Értesítési Beállítások',
  pushNotifications: 'Push Értesítések',
  notificationsEnabled: 'Értesítések engedélyezve',
  notificationsDisabled: 'Értesítések letiltva',
  enable: 'Engedélyezés',
  notificationPreferences: 'Értesítési Beállítások',
  tripUpdates: 'Utazás Frissítések',
  tripUpdatesDescription: 'Értesítés utazások frissítéséről',
  tripSharedNotif: 'Utazás Megosztás',
  tripSharedNotifDescription: 'Értesítés ha valaki megoszt veled egy utazást',
  collaboratorNotif: 'Közreműködő Hozzáadva',
  collaboratorNotifDescription: 'Értesítés ha közreműködőként hozzáadnak',
  stopChanges: 'Megálló Változások',
  stopChangesDescription: 'Értesítés megállók hozzáadásakor vagy törlésekor',
  costChanges: 'Költség Változások',
  costChangesDescription: 'Értesítés költségek hozzáadásakor vagy módosításakor',
  notificationHistory: 'Értesítési Előzmények',
  noNotifications: 'Még nincs értesítés',
  markAllRead: 'Összes Olvasottnak Jelölése',
  notificationsEnabledSuccess: 'Értesítések sikeresen engedélyezve',
  notificationsEnableFailed: 'Értesítések engedélyezése sikertelen',
  preferencesSaved: 'Beállítások mentve',
  allNotificationsMarkedRead: 'Minden értesítés olvasottnak jelölve',
  
  // Offline Mode
  offlineMode: 'Offline Mód',
  online: 'Online',
  offline: 'Offline',
  connectionType: 'Kapcsolat',
  cellular: 'Mobilnet',
  pendingChanges: 'Függőben lévő változások',
  cacheSize: 'Gyorsítótár mérete',
  lastSync: 'Utolsó szinkronizálás',
  offlineModeDescription: 'Dolgozz offline és szinkronizáld a változásokat amikor a kapcsolat helyreáll',
  clearOldCache: 'Régi gyorsítótár törlése',
  clearAllCache: 'Összes gyorsítótár törlése',
  confirmClearAllCache: 'Ez törli az összes offline adatot. Folytatod?',
  clear: 'Törlés',
  pendingActions: 'Függőben lévő műveletek',
  syncingOfflineChanges: 'Offline változások szinkronizálása...',
  backOnline: 'Ismét online',
  workingOffline: 'Offline módban dolgozol',
  sync: 'Szinkronizálás',
  syncing: 'Szinkronizálás...',
  syncComplete: 'Szinkronizálás befejezve',
  syncFailed: 'Szinkronizálás sikertelen',
  oldCacheCleared: 'Régi gyorsítótár törölve',
  allCacheCleared: 'Összes gyorsítótár törölve',
  update: 'Frissítés',
  
  // Placeholders
  tripNamePlaceholder: 'pl. Nyári Roadtrip',
  searchAddress: 'Cím keresése...',
  notesPlaceholder: 'Megjegyzések erről a megállóról...',
  
  // Premium Features
  premium: 'Prémium',
  freeTier: 'Ingyenes',
  upgradedSuccessfully: 'Sikeresen frissítettél Prémiumra!',
  upgradeFailed: 'A frissítés sikertelen. Kérlek próbáld újra.',
  unlockAllFeatures: 'Összes Funkció Feloldása',
  getFullAccess: 'Szerezz teljes hozzáférést az összes prémium funkcióhoz',
  month: 'hónap',
  unlimitedTrips: 'Korlátlan utazások',
  unlimitedStops: 'Korlátlan megállók utazásonként',
  unlimitedVehicles: 'Korlátlan járművek',
  offlineMaps: 'Offline térképek',
  advancedStatistics: 'Haladó statisztikák',
  exportFeatures: 'Export PDF és Excel formátumban',
  adFree: 'Reklámmentes élmény',
  prioritySupport: 'Elsőbbségi támogatás',
  processing: 'Feldolgozás...',
  moneyBackGuarantee: '30 napos pénzvisszafizetési garancia',
  freeTierLimits: 'Ingyenes Verzió Korlátai',
  maxOneTrip: 'Maximum 1 aktív utazás',
  maxOneVehicle: 'Maximum 1 jármű',
  maxTwelveStops: 'Maximum 12 megálló utazásonként',
  basicStatisticsOnly: 'Csak alapvető statisztikák',
  viewingDemo: 'Demó Utazás Megtekintése',
  signInToCreate: 'Jelentkezz be saját utazások létrehozásához',
  demoMode: 'Demó Mód',
  freeTierLimit: 'Ingyenes Limit Elérve',
  upgradeForUnlimitedTrips: 'Frissíts Prémiumra korlátlan utazásokért és haladó funkciókért'
}
